import React, { useState, useEffect } from 'react'
import { vehicleDetialModel } from './vehicleDetialModel'
import { YhPrint, IPrintClumns } from '@/components/YhPrint'
import moment from 'moment'
import { useGlobalModel } from '@/model/globalModel'
import { useOrderModel } from '../../orderModel'
import { orderService } from '../../orderService'
import { formatNum } from '@/utils/utils'

export function Print() {
    const { selectedRowKeys: customerVehicleCodeList, searchParam, fleetName, companyName } = useOrderModel()
    const { selectedRowKeys: orderCodeList, print, vehicleFormVal, setPrint, printStatus, vehicleSearchParam } = vehicleDetialModel()
    const { user } = useGlobalModel()
    const [dataList, setDataList] = useState<any>([])
    useEffect(() => {
        let data = {}
        if (printStatus === 'outDetial') {
            data = {
                ...searchParam,
                fleet: fleetName !== '全部' ? fleetName : '',
                company: companyName !== '全部' ? companyName : '',
                customerVehicleCode: customerVehicleCodeList.length > 0 ? customerVehicleCodeList.map((item) => item.customerVehicleCode).toString() : '',
                // startTime:"",
                // endTime:"",
                // orderCode:""
            }
        } else {
            data = {
                ...vehicleSearchParam,
                // fleet:"",
                // company:"",
                customerVehicleCode: vehicleFormVal.customerVehicleCode,
                orderCode: orderCodeList.length > 0 ? orderCodeList.map((item) => item.orderCode).toString() : '',
            }
        }
        orderService
            .printDetial(data)
            .then((result: any) => {
                let newData = result.retData?.map((item, index) => {
                    return {
                        ...item,
                        1: '云豪',
                        2: '外修',
                        unitPrice: formatNum(item.unitPrice),
                        materAmount: formatNum(item.materAmount),
                        actualAmount: formatNum(item.actualAmount),
                        No: index + 1,
                    }
                })
                setDataList(newData)
            })
            .catch((err) => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [print])

    const columns = [
        // {
        //     title: '序号',
        //     width: 60,
        //     fixed: "left",
        //     render: (t, r, i:number) => i + 1
        // },
        // {
        //     title: '工单编号',
        //     width: 160,
        //     dataIndex: 'orderCode',
        // }, {
        //     title: '工单类型',
        //     width: 100,
        //     dataIndex: 'orderType',
        //     render: (t, r, i) => orderTypeEnum[t],
        // }, {
        //     title: '服务地点',
        //     width: 160,
        //     dataIndex: 'repairAddress',
        // }, {
        //     title: '登记日期',
        //     width: 140,
        //     dataIndex: 'createTime',
        // }, {
        //     title: '完工日期',
        //     width: 140,
        //     dataIndex: 'orderCompletedTime',
        // }, {
        //     title: '故障描述',
        //     width: 160,
        //     dataIndex: 'faultDesc',
        // }, {
        //     title: '维修团队',
        //     width: 160,
        //     dataIndex: 'teamName',
        // }, {
        //     title: '处理结果',
        //     width: 160,
        //     dataIndex: 'processResult',
        // },
        // // {
        // //     title: '实收金额',
        // //     width: 100,
        // //     dataIndex: 'orderActualAmount',
        // // },
        //  {
        //     title: '审核人',
        //     width: 100,
        //     dataIndex: 'reviewerName',
        // }, {
        //     title: '工单状态',
        //     width: 100,
        //     dataIndex: 'orderStatus',
        //     render: (t, r, i) => orderStatusEnum[t],
        // }, {
        //     title: '备注',
        //     width: 160,
        //     dataIndex: 'remark',
        // },
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            // render: (t, r, i:number) => i + 1
            dataIndex: 'No',
        },
        {
            title: '现场',
            width: 160,
            dataIndex: 'fleet',
        },
        {
            title: '车牌',
            width: 160,
            dataIndex: 'customerVehicleCode',
        },
        {
            title: '工单编号',
            width: 160,
            dataIndex: 'orderCode',
        },
        {
            title: '日期',
            width: 160,
            dataIndex: 'createTime',
        },
        {
            title: '供应商',
            width: 160,
            dataIndex: '1',
        },
        {
            title: '维修点',
            width: 160,
            dataIndex: '2',
        },
        {
            title: '类型',
            width: 160,
            dataIndex: 'serviceType',
        },
        {
            title: '部位',
            width: 160,
            dataIndex: '',
        },
        {
            title: '维修内容',
            width: 160,
            dataIndex: 'itemName',
        },
        {
            title: '用时(H)',
            width: 160,
            dataIndex: 'itemWorkHour',
        },
        {
            title: '人工费',
            width: 160,
            dataIndex: 'actualAmount',
        },
        {
            title: '品种',
            width: 160,
            dataIndex: 'materialName',
        },
        {
            title: '数量',
            width: 160,
            dataIndex: 'materialNumber',
        },
        {
            title: '单价',
            width: 160,
            dataIndex: 'unitPrice',
        },
        {
            title: '费用',
            width: 160,
            dataIndex: 'materAmount',
        },
        {
            title: '品种',
            width: 160,
            dataIndex: '',
        },
        {
            title: '费用',
            width: 160,
            dataIndex: '',
        },
        {
            title: '折扣',
            width: 160,
            dataIndex: '',
        },
        {
            title: '费用总额',
            width: 160,
            dataIndex: 'orderActualAmount',
        },
        {
            title: '成本中心',
            width: 160,
            dataIndex: '',
        },
    ]

    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: '打印时间',
                fieldValue: moment().format('YYYY-MM-DD HH:mm:ss'), //当前时间
                className: 'pagination',
            },
        ],
        footer: [
            {
                fieldLabel: '制表人',
                fieldValue: user.userName,
                className: 'w50',
            },
        ],
    }
    const [paperSize] = useState<number>(40) //打印的商品条数  (没有单价的多展示两条商品)
    const modalTitle = (
        <>
            <span style={{ marginRight: '15px' }}>打印详情</span>
            {/* <Radio.Group onChange={(e) => setPaperSize(e.target.value)} value={paperSize}>
			<Radio value={type === "1" ? 44 : 45}>A4</Radio>
			<Radio value={type === "1" ? 39 : 40}>10x11</Radio>
		</Radio.Group> */}
        </>
    )

    return (
        <YhPrint
            modalTitle={modalTitle}
            title="车辆维保工单"
            visible={print}
            onClose={() => {
                setPrint(false)
                setDataList([])
            }}
            columns={columns as IPrintClumns[]}
            dataSource={dataList}
            printShow={printShow}
            paperSize={paperSize}
        />
    )
}

export default Print
